module.exports = __webpack_public_path__ + "img/mem_gogo.fb4b03dd.gif";